<div class="mapping-page-main">
  <hhsg-mapping-header [entityName]="entityName"></hhsg-mapping-header>
  <div
    class="mapping-page-inner"
    infiniteScroll
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="scrollThrottle"
    [fromRoot]="false"
    [scrollWindow]="false"
    [infiniteScrollContainer]="scrollSelector"
    (scrolled)="onScrollDown()">
    <hhsg-mapping-container
      [ngStyle]="{ width: menuWidth }"
      [sortOptions]="sortOptions"
      [mappingDetailTemplate]="mappingDetailTemplate"
      [legendTemplate]="legendTemplate"
      [mappings]="mappings"
      [hasLegends]="hasLegends"
      (onSelectionEvent)="onSelection($event)"
      (sortUpDownChangeEvent)="onChangeSortOrder()"
      [selection]="selection"
      (searchChangeEvent)="searchText = $event.target.value; onSearchKey($event)"
      class="mapping-left-main"
      (sortTypeChangeEvent)="onSortTypesDropDownChanged($event)"
      (setSelectedFilterEvent)="setSelectedFilter($event)"
      (selectedFilterEvent)="(selectedFilter)"></hhsg-mapping-container>

    <hhsg-mapping-detail
      [ngStyle]="{ width: 'calc(100% - ' + menuWidth }"
      [mappingForm]="mappingForm"
      [hasfooter]="hasfooter"
      [buttonIsDisabled]="isSaveButtonDisabled()"
      (onSaveEvent)="onSave()"
      (onCancelEvent)="onCancel()"
      (onDialogSaveEvent)="onDialogSave()"
      [adminActionLoading]="adminActionLoading"
      [errorMessage]="getErrorMessage()"
      class="mapping-detail-main"
      [filterEntities]="filterEntities"
      [filterEntityId]="filterEntityId"
      [filterEntityDisplayName]="filterEntityDisplayName"
      [typeDropdownTemplate]="typeDropdownTemplate"
      [mappingDialogTemplate]="mappingDialogTemplate"
      [adminActionLabelText]="adminActionLabelText"
      (beforeFilterEntityDropDownChangedEvent)="beforeFilterEntityDropDownChanged($event)">
      <ng-content select="[mappingFormBody]" ngProjectAs="[mappingFormBody]"></ng-content>
    </hhsg-mapping-detail>
  </div>
  <div class="spinner-container" *ngIf="initialLoading || mobileLoading || headerButtonLoading || adminActionLoading">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
</div>
